import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ExpandIcon, ExpandDialog } from '@/components/ui/expand-dialog';
import { cn } from '@/lib/utils';

interface DescriptionTextProps {
  text: string;
  /** Max characters before showing expand icon */
  maxChars?: number;
  className?: string;
  /** Render as markdown in expanded dialog */
  markdown?: boolean;
}

export function DescriptionText({
  text,
  maxChars = 20,
  className,
  markdown = false,
}: DescriptionTextProps) {
  const [open, setOpen] = useState(false);
  const isLong = text && text.length > maxChars;
  const display = isLong ? text.slice(0, maxChars) + '…' : text || '-';

  return (
    <span className={cn('inline-flex items-center gap-1 min-w-0', className)}>
      <span className="truncate" title={text || ''}>
        {display}
      </span>
      {isLong && <ExpandIcon onClick={() => setOpen(true)} />}

      <ExpandDialog open={open} onClose={() => setOpen(false)} title="描述">
        {markdown ? (
          <div className="px-5 py-4">
            {text.trim() ? (
              <div className="prose prose-sm max-w-none dark:prose-invert prose-headings:font-semibold prose-p:my-2 prose-li:my-0 prose-code:rounded prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:text-xs prose-pre:bg-muted prose-pre:p-3">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground">暂无内容</p>
            )}
          </div>
        ) : (
          <p className="whitespace-pre-wrap px-5 py-4 text-sm leading-relaxed">{text}</p>
        )}
      </ExpandDialog>
    </span>
  );
}
